export enum CaseType {
  ift = "ift",
  mih = "mih"
}
